import { useState } from 'react';

/**
 * Shows an invite accept URL with a copy button. Email delivery is SCO-50 — until then
 * the inviter shares this link manually.
 */
export function InviteLink({ url, label }: { url: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="invite-link">
      <span className="muted small">{label ?? 'Invite link — share it with them:'}</span>
      <div className="invite-link-row">
        <code>{url}</code>
        <button
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(url);
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            } catch {
              /* clipboard blocked — the URL is visible to select manually */
            }
          }}
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </div>
  );
}
